import React, { useContext } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import Context from './context';
import Item from './components/item';
import * as styles from './list.styles';

/** @type {import(".").ListType} */
const List = ({
  className,
  // Using context adds support for nested lists
  variant: propVariant,
  children,
  ...props
}) => {
  const contextVariant = useContext(Context);
  const variant = propVariant || contextVariant;
  const tag = variant === 'ordered' ? 'ol' : 'ul';
  return (
    <Context.Provider value={variant}>
      <Element as={tag} className={clsx(styles.list, variant, className)} {...props}>
        {children}
      </Element>
    </Context.Provider>
  );
};

if (process.env.NODE_ENV !== 'production') {
  List.displayName = 'List';
}

List.Item = Item;

export default List;
